export function getCategoryBucketItemCount(items: unknown): number {
  return Array.isArray(items) ? items.length : 0
}

export function getCategoryBucketItems<T>(items: T[] | null | undefined): T[] {
  return Array.isArray(items) ? items : []
}
